import { initAccordions } from './commons/_accordion';
import { initSmoothScroll } from './commons/_smooth-scroll';

$(document).ready(function () {
    initAccordions();
    initSmoothScroll();
});
